import { useToast } from '@entur/alert'
import { Fetch, FetchState, TicketRight } from '../api-clients/api-types'
import { useApi } from '../api-clients/client-hooks'
import { postSyncTicketRight, postTicketRights } from '../api-clients/eba-clients'
import { useEmployee } from '../contexts/employee-context'
import { useFamilyMembers } from '../contexts/family-members-context'
import { trackEvent } from '../utils/tracking-utils'

export function useGenerateTicketRights(
  successCallback?: (ticketRights: TicketRight[]) => void
): [Fetch<TicketRight[]>, () => void] {
  const { addToast } = useToast()
  const { employee, setTicketRights } = useEmployee()
  const { setTicketRights: setTicketRightsFamilyMembers } = useFamilyMembers()
  const [generateTicketRightsResponse, generate] = useApi(postTicketRights, {
    successCallback: (data) => {
      const ticketRights = data.filter(
        (it) => it.ticketRightsHolder?.ticketHolderCode === employee.ticketHolderCode
      )
      setTicketRights(ticketRights)
      setTicketRightsFamilyMembers(data)
      if (successCallback) {
        successCallback(data)
      }
      addToast('Rettighetseier er oppdatert!')
    },
  })

  const generateTicketRights = () => {
    trackEvent('Generate-Ticket-Rights', { category: 'Employee' })
    generate({
      id: employee.id,
      body: {},
    })
  }

  return [generateTicketRightsResponse, generateTicketRights]
}

export function useSyncTicketRights(
  successCallback: (ticketRight: TicketRight) => void
): [Fetch<TicketRight>, (ticketRight: TicketRight, shouldSync: boolean) => void] {
  const { employee, setTicketRight: setEmployeeTicketRight } = useEmployee()
  const { familyMembersResponse, setTicketRight: setFamilyMemberTicketRight } = useFamilyMembers()
  const [syncTicketRightResponse, sync] = useApi(postSyncTicketRight, {
    successCallback: (data) => {
      const belongsToEmployee = employee.ticketRights?.find((it) => it.ticketrightId === data.ticketrightId)
      if (belongsToEmployee) {
        setEmployeeTicketRight(data)
      } else if (familyMembersResponse.status === FetchState.SUCCESS) {
        setFamilyMemberTicketRight(data)
      }
      successCallback(data)
    },
  })

  const syncTicketRight = (ticketRight: TicketRight, shouldSync: boolean) => {
    trackEvent('Sync-Ticket-Right', { category: 'Employee' })
    sync({
      id: ticketRight.ticketrightId.toString(),
      body: {
        syncToEss: shouldSync,
      },
    })
  }

  return [syncTicketRightResponse, syncTicketRight]
}
